<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <br>
    <template>
      <v-container
        v-if="enableRadioGroup"
        id="radioGroupBarChart"
      >
        <v-radio-group
          v-model="selectedFatVolume"
          row
        >
          <v-radio
            label="Faturamento"
            value="graficoFaturamento"
          />
          <v-radio
            label="Volume"
            value="graficoVolume"
          />
        </v-radio-group>
      </v-container>
      <br><br><br>
      <canvas
        id="myChart7"
      />
    </template>
    <div
      v-if="exibirLegenda"
      id="legendaVendas"
      class="text-center px-3"
    >
      <v-row
        align="center"
        class="ma-0"
      >
        <v-avatar
          class="mr-1"
          color="#ed934f"
          size="10"
        />
        <span class="mr-3 font-weight-light">Variação Anual de Faturamento</span>
        <v-avatar
          class="mr-1"
          color="#cadaed"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Ano Anterior</span>
        <v-avatar
          class="mr-1"
          color="#4780b8"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Corrente</span>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Vendas from '../../../../services/vendas4'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardVendas7MesesAnteriores',
    emits: ['updateDadosSomatorio'],
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      select: [],
      supervisor: [],
      vendedores: [],
      areas: [],
      redes: [],
      receita: [],
      segmento: [],
      classificacoes: [],
      categoria: [],
      promotor: [],
      linhaProducao: [],
      valorRestante: false,
      loading: false,
      error: null,
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart1: {},
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      montarGrafico: true,
      text: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      selectedFatVolume: 'graficoFaturamento',
      enableRadioGroup: false,
      datasFaturamento: [],
      faturamentoAnoAnterior: [],
      faturamentoCorrente: [],
      valoresExibicao: [],
      somatorioFaturamento: 0,
      somatorioFaturamentoAnterior: 0,
      porcentagem: [],
      volumeAnoAnterior: [],
      volumeCorrente: [],
      valoresExibicaoVolume: [],
      porcentagemVolume: [],
      somatorioVolume: 0,
      somatorioVolumeAnterior: 0,
    }),

    watch: {
      selectedFatVolume (newVal) {
        this.renderChart(newVal)
      },
    },

    created () {
      eventEmit.$on('update-datas-vendas', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-datas-vendas', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, vendedores, areas, redes, receita, segmento, classificacoes, categoria, promotor, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.vendedores = vendedores
        this.areas = areas
        this.redes = redes
        this.receita = receita
        this.segmento = segmento
        this.classificacoes = classificacoes
        this.categoria = categoria
        this.promotor = promotor
        this.linhaProducao = linhaProducao

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.datasFaturamento = []
        this.faturamentoAnoAnterior = []
        this.faturamentoCorrente = []
        this.valoresExibicao = []
        this.somatorioFaturamento = 0
        this.somatorioFaturamentoAnterior = 0
        this.porcentagem = []
        this.volumeAnoAnterior = []
        this.volumeCorrente = []
        this.valoresExibicaoVolume = []
        this.porcentagemVolume = []
        this.somatorioVolume = 0
        this.somatorioVolumeAnterior = 0

        this.exibirLegenda = false
        this.enableRadioGroup = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Vendas.showDadosFaturamentoMesesAnteriores(this.select, this.supervisor, localStorage.tokencontrato, this.vendedores, this.areas, this.redes, this.classificacoes, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.datasFaturamento = resposta.data.datasFaturamento
            this.faturamentoAnoAnterior = resposta.data.faturamentoAnoAnterior
            this.faturamentoCorrente = resposta.data.faturamentoCorrente
            this.valoresExibicao = resposta.data.valoresExibicao
            this.somatorioFaturamento = resposta.data.somatorioAnoCorrente
            this.somatorioFaturamentoAnterior = resposta.data.somatorioAnoAnterior
            this.porcentagem = resposta.data.porcentagem
            this.volumeAnoAnterior = resposta.data.volumeAnoAnterior
            this.volumeCorrente = resposta.data.volumeCorrente
            this.valoresExibicaoVolume = resposta.data.valoresExibicaoVolume
            this.porcentagemVolume = resposta.data.porcentagemVolume
            this.somatorioVolume = resposta.data.somatorioAnoCorrenteVolume
            this.somatorioVolumeAnterior = resposta.data.somatorioAnoAnteriorVolume

            this.selectedFatVolume = 'graficoFaturamento'

            const ctx = document.getElementById('myChart7').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: this.datasFaturamento,
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: this.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: this.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: this.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return this.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })

            eventEmit.$emit('update-dados-somatorio', this.somatorioFaturamento, this.somatorioFaturamentoAnterior, 'Comparativo Faturamento', true)
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true

          this.enableRadioGroup = true
        })
      },

      renderChart (tipo) {
        if (this.myChart.data) {
          this.myChart.destroy()
        }

        const ctx = document.getElementById('myChart7').getContext('2d')

        setTimeout(() => {
          if (tipo === 'graficoFaturamento') {
            eventEmit.$emit('update-dados-somatorio', this.somatorioFaturamento, this.somatorioFaturamentoAnterior, 'Comparativo Faturamento', true)

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: this.datasFaturamento,
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: this.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: this.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: this.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return this.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (tipo === 'graficoVolume') {
            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: this.datasFaturamento,
                datasets: [
                  {
                    label: 'VolumeAnoAnterior',
                    data: this.volumeAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Volume',
                    data: this.volumeCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: this.valoresExibicaoVolume,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return this.porcentagemVolume[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })

            eventEmit.$emit('update-dados-somatorio', this.somatorioVolume, this.somatorioVolumeAnterior, 'Comparativo Volume', false)
          }
        }, 500)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #myChart7
    margin-top: -5rem

  #legendaVendas
    font-size: 12px
    margin: 1rem 0 0 5rem

  #radioGroupBarChart
    margin: -3rem 0 2rem 0
</style>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #myChart7 {
      margin: -5rem 0 0 0;
      width: 400px !important;
      height: 175px !important;
    }

    #legendaVendas {
      font-size: 9px;
      margin: 0 0 0 0
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart7 {
      margin: -3rem 0 0 6rem;
      width: 780px !important;
      height: 364px !important;
    }

    #legendaVendas {
      font-size: 12px;
      margin: 1rem 0 0 7rem;
    }
  }
</style>
